import { render } from "./PartnerStatistics.vue?vue&type=template&id=7bf8665f"
import script from "./PartnerStatistics.vue?vue&type=script&lang=js"
export * from "./PartnerStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__